import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../ui/Logo';
import Icon from '../ui/Icon';

const Footer = () => {
  const columns = [
    {
      title: 'Tools',
      links: [
        { label: 'PDF to Word', to: '/tool/pdf-to-word' },
        { label: 'Word to PDF', to: '/tool/word-to-pdf' },
        { label: 'Compress PDF', to: '/tool/compress-pdf' },
        { label: 'Merge PDF', to: '/tool/merge-pdf' },
        { label: 'Sign PDF', to: '/tool/sign-pdf' },
        { label: 'All Tools', to: '/tools' },
      ],
    },
    {
      title: 'Image Tools',
      links: [
        { label: 'Remove Background', to: '/tool/bg-remove' },
        { label: 'Resize Image', to: '/tool/image-resize' },
        { label: 'Compress Image', to: '/tool/image-compress' },
        { label: 'Convert Image', to: '/tool/image-convert' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About', to: '#' },
        { label: 'Blog', to: '#' },
        { label: 'Careers', to: '#' },
        { label: 'Contact', to: '#' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy Policy', to: '#' },
        { label: 'Terms of Service', to: '#' },
        { label: 'Cookie Policy', to: '#' },
        { label: 'GDPR', to: '#' },
      ],
    },
  ];

  return (
    <footer className="relative mt-24" style={{ background: 'var(--bg-secondary)', borderTop: '1px solid var(--border-light)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          {/* Brand */}
          <div className="col-span-2">
            <Logo size="md" />
            <p className="mt-4 text-sm max-w-xs" style={{ color: 'var(--text-secondary)' }}>
              Your universe of document tools. Convert, edit, sign, and manage documents with unprecedented ease.
            </p>
            <div className="flex gap-3 mt-6">
              {['Twitter', 'GitHub', 'LinkedIn'].map(s => (
                <a key={s} href="#" className="w-9 h-9 rounded-lg flex items-center justify-center transition-colors hover:bg-black/5"
                  style={{ background: 'var(--bg-tertiary)' }}>
                  <Icon name="ExternalLink" size={14} />
                </a>
              ))}
            </div>
          </div>
          {/* Columns */}
          {columns.map(col => (
            <div key={col.title}>
              <h4 className="text-sm font-bold mb-4" style={{ color: 'var(--text-primary)' }}>{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map(link => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm transition-colors hover:text-brand-600"
                      style={{ color: 'var(--text-muted)' }}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" style={{ borderTop: '1px solid var(--border-light)' }}>
          <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
            © 2026 DocuVerse. All rights reserved. Made with care for the world's documents.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs" style={{ color: 'var(--text-muted)' }}>🔒 Your files are encrypted & deleted after 2 hours</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
